const WEBVIEW_IMAGE_STYLES =
  'img { display: block; max-width: 100%; height: auto; }';
const WEBVIEW_FONT_SIZE = 'body { font-size:14px }';

export const appendStyleToWebViewContent = () => {
  return `<style> ${WEBVIEW_IMAGE_STYLES} ${WEBVIEW_FONT_SIZE}</style>`;
};
